import { render } from "./Faq.vue?vue&type=template&id=119166be&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=119166be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-119166be"

export default script